/**
 * Aptitude Technologies — Website JS bundle
 * - Navigation responsive toggle
 * - Lang switch (cookie preferred_language)
 * - Cookie banner minimal (Loi 25 friendly)
 *
 * Compilé par esbuild :
 *   apps/aptitude_website/aptitude_website/public/js/website.bundle.js
 *   -> public/dist/js/website.bundle.<HASH>.js
 */

(function () {
	'use strict';

	// Horodatage de chargement du bundle : sert au time-trap anti-spam (temps
	// écoulé avant soumission). Calculé côté client car les pages sont mises en
	// cache (Cloudflare/Frappe) — un jeton rendu par le serveur serait périmé.
	var _bundleLoadedAt = Date.now();

	// Attribution campagne (source + utm_*) : clés suivies + mémoire de session.
	var ATTR_KEYS = ['source', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
	var ATTR_STORE_KEY = 'aw_attr';

	function ready(fn) {
		if (document.readyState !== 'loading') {
			fn();
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	}

	ready(function () {
		initNavToggle();
		initNavGroup();
		initNavDropdown();
		initLangSwitch();
		initCookieBanner();
		initSmoothScroll();
		initForms();
		initStepperForms();
	});

	// --- Navigation responsive ----------------------------------------------
	function initNavToggle() {
		var toggle = document.querySelector('[data-nav-toggle]');
		var nav = document.querySelector('[data-nav]');
		var backdrop = document.querySelector('[data-nav-backdrop]');
		var header = document.querySelector('[data-site-header]');
		var shell = document.querySelector('.at-navbar__shell');
		var body = document.body;
		var mobileMq = window.matchMedia('(max-width: 1149.98px)');
		var lockedScrollY = 0;
		if (!toggle || !nav) return;

		function syncHeaderHeight() {
			if (!header) return;
			document.documentElement.style.setProperty(
				'--at-mobile-header-height',
				header.offsetHeight + 'px'
			);
		}

		function placeNavElements() {
			if (mobileMq.matches) {
				if (backdrop && backdrop.parentNode !== body) body.appendChild(backdrop);
				if (nav.parentNode !== body) body.appendChild(nav);
				nav.classList.add('at-nav--mobile-root');
			} else {
				nav.classList.remove('at-nav--mobile-root');
				if (shell && nav.parentNode !== shell) shell.appendChild(nav);
				if (header && backdrop && backdrop.parentNode !== header) header.appendChild(backdrop);
				setNavOpen(false);
			}
			syncHeaderHeight();
		}

		function lockPageScroll(open) {
			if (!body) return;
			if (open) {
				lockedScrollY = window.scrollY || window.pageYOffset || 0;
				body.style.position = 'fixed';
				body.style.top = '-' + lockedScrollY + 'px';
				body.style.left = '0';
				body.style.right = '0';
				body.style.width = '100%';
			} else {
				body.style.position = '';
				body.style.top = '';
				body.style.left = '';
				body.style.right = '';
				body.style.width = '';
				window.scrollTo(0, lockedScrollY);
			}
		}

		function setNavOpen(open) {
			if (!mobileMq.matches) open = false;
			nav.classList.toggle('is-open', open);
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			var label = open
				? (toggle.getAttribute('data-label-close') || 'Close menu')
				: (toggle.getAttribute('data-label-open') || 'Open menu');
			toggle.setAttribute('aria-label', label);
			var iconMenu = toggle.querySelector('.at-nav-toggle__icon--menu');
			var iconClose = toggle.querySelector('.at-nav-toggle__icon--close');
			if (iconMenu) iconMenu.hidden = !!open;
			if (iconClose) iconClose.hidden = !open;
			if (backdrop) {
				backdrop.hidden = true;
				backdrop.classList.remove('is-visible');
				backdrop.setAttribute('aria-hidden', 'true');
			}
			lockPageScroll(open);
			document.documentElement.classList.toggle('at-nav-open', open);
		}

		placeNavElements();
		setNavOpen(false);
		if (mobileMq.addEventListener) mobileMq.addEventListener('change', placeNavElements);
		else mobileMq.addListener(placeNavElements);
		window.addEventListener('resize', syncHeaderHeight);

		toggle.addEventListener('click', function () {
			if (!mobileMq.matches) return;
			syncHeaderHeight();
			setNavOpen(!nav.classList.contains('is-open'));
		});

		if (backdrop) {
			backdrop.addEventListener('click', function () {
				setNavOpen(false);
			});
		}

		nav.querySelectorAll('[data-nav-close]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				setNavOpen(false);
				toggle.focus();
			});
		});

		nav.querySelectorAll('a.at-nav__link, .at-nav__cta a').forEach(function (link) {
			link.addEventListener('click', function () {
				setNavOpen(false);
			});
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && nav.classList.contains('is-open')) {
				setNavOpen(false);
				toggle.focus();
			}
		});
	}

	// --- Groupe « Services » repliable (menu mobile) ------------------------
	// Sur grand écran le bouton est masqué (CSS display:contents) ; sur mobile
	// il replie/déplie le sous-menu des piliers de services.
	function initNavGroup() {
		var toggles = document.querySelectorAll('[data-nav-group-toggle]');
		Array.prototype.forEach.call(toggles, function (btn) {
			btn.addEventListener('click', function () {
				var group = btn.closest('[data-nav-group]');
				if (!group) return;
				var open = group.classList.toggle('is-open');
				btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			});
		});
	}

	// --- Dropdown ERPNext / IA (menu mobile) --------------------------------
	// Sur mobile : toggle accordéon imbriqué dans le groupe Services.
	// Sur desktop : hover/focus-within géré par CSS.
	function initNavDropdown() {
		var mobileMq = window.matchMedia('(max-width: 1149.98px)');
		var toggles = document.querySelectorAll('[data-nav-dropdown-toggle]');
		
		Array.prototype.forEach.call(toggles, function (btn) {
			btn.addEventListener('click', function (e) {
				// Sur desktop, le dropdown s'ouvre au hover/focus (CSS)
				if (!mobileMq.matches) {
					e.preventDefault();
					return;
				}
				
				var dropdown = btn.closest('[data-nav-dropdown]');
				if (!dropdown) return;
				
				// Fermer les autres dropdowns ouverts
				document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (other) {
					if (other !== dropdown) {
						other.classList.remove('is-open');
						var otherBtn = other.querySelector('[data-nav-dropdown-toggle]');
						if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
					}
				});
				
				var open = dropdown.classList.toggle('is-open');
				btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			});
		});

		// Fermeture Escape sur mobile
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && mobileMq.matches) {
				document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (dropdown) {
					dropdown.classList.remove('is-open');
					var btn = dropdown.querySelector('[data-nav-dropdown-toggle]');
					if (btn) btn.setAttribute('aria-expanded', 'false');
				});
			}
		});
	}

	// --- Lang switch (FR <-> EN) --------------------------------------------
	// On stocke la préférence dans le cookie `preferred_language` que Frappe
	// utilise nativement. Le clic sur un lien /en/... ou / suffit à changer
	// la page; on persiste juste le choix.
	function initLangSwitch() {
		var links = document.querySelectorAll('[data-lang]');
		links.forEach(function (link) {
			link.addEventListener('click', function () {
				var lang = link.getAttribute('data-lang');
				if (!lang) return;
				setCookie('preferred_language', lang, 365);
			});
		});
	}

	// --- Cookie banner -------------------------------------------------------
	function initCookieBanner() {
		var banner = document.querySelector('[data-cookie-banner]');
		if (!banner) return;
		if (getCookie('at_cookie_consent')) return;
		banner.classList.add('is-visible');

		var accept = banner.querySelector('[data-cookie-accept]');
		if (accept) {
			accept.addEventListener('click', function () {
				setCookie('at_cookie_consent', 'accepted', 365);
				banner.classList.remove('is-visible');
			});
		}
	}

	// --- Smooth scroll pour les ancres internes ------------------------------
	function initSmoothScroll() {
		document.querySelectorAll('a[href^="#"]').forEach(function (a) {
			a.addEventListener('click', function (e) {
				var id = a.getAttribute('href');
				if (id === '#' || id.length < 2) return;
				var target = document.querySelector(id);
				if (!target) return;
				e.preventDefault();
				target.scrollIntoView({ behavior: 'smooth', block: 'start' });
				if (history.pushState) history.pushState(null, '', id);
			});
		});
	}

	// --- Soumission AJAX des formulaires ------------------------------------
	// Tout formulaire avec [data-form-endpoint="<frappe-method-path>"] est
	// envoyé en JSON via fetch vers /api/method/<endpoint>. Les champs file
	// sont encodés en base64 sous les clés <name>_data + <name>_filename.
	function initForms() {
		document.querySelectorAll('form[data-form-endpoint]').forEach(function (form) {
			form.addEventListener('submit', function (e) {
				e.preventDefault();
				submitForm(form);
			});
			
			// Track form_start on first interaction with any field
			var startTracked = false;
			var fields = form.querySelectorAll('input:not([type="hidden"]), textarea, select');
			fields.forEach(function(field) {
				var trackStart = function() {
					if (startTracked) return;
					startTracked = true;
					if (typeof window.__atTrackFormStart === 'function') {
						try {
							window.__atTrackFormStart();
						} catch (e) { /* noop */ }
					}
				};
				field.addEventListener('focus', trackStart, { once: true });
				field.addEventListener('input', trackStart, { once: true });
			});
		});
	}

	async function submitForm(form) {
		clearErrors(form);
		if (!validateForm(form)) {
			setStatus(form, 'error', form.dataset.msgInvalid || 'Veuillez corriger les champs en rouge.');
			return;
		}
		var endpoint = form.dataset.formEndpoint;
		var redirect = form.dataset.formRedirect || '/merci';
		setStatus(form, 'loading', form.dataset.msgLoading || 'Envoi en cours…');
		setSubmitting(form, true);

		try {
			var payload = await formToPayload(form);
			mergeAttribution(payload);
			addAntispamSignals(payload);
			var resp = await fetch('/api/method/' + endpoint, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/json', 'X-Frappe-CSRF-Token': window.frappe && window.frappe.csrf_token ? window.frappe.csrf_token : 'guest' },
				body: JSON.stringify(payload),
			});
			var data = null;
			try { data = await resp.json(); } catch (e) { data = null; }

		if (!resp.ok || !data || !data.message || data.message.ok !== true) {
			var msg = (data && data._server_messages) ? extractServerMessage(data._server_messages) : null;
			if (!msg && data && data.message && data.message.error) {
				msg = data.message.error;
			}
			setStatus(form, 'error', msg || (form.dataset.msgError || 'Une erreur est survenue.'));
			setSubmitting(form, false);
			return;
		}

		// Succès API mais sans ref : anti-spam silencieux ou erreur serveur.
		// Ne jamais rediriger vers Merci sans ref — afficher une erreur visible.
		var ref = data.message.ref || '';
		if (!ref) {
			setStatus(form, 'error', form.dataset.msgError || 'Une erreur est survenue. Réessayez ou contactez-nous.');
			setSubmitting(form, false);
			return;
		}

		await trackLeadConversion(endpoint, payload);
		
		// Small delay to ensure beacon is sent before redirect
		await new Promise(function(resolve) { setTimeout(resolve, 150); });

		var sep = redirect.indexOf('?') > -1 ? '&' : '?';
		window.location.href = redirect + sep + 'ref=' + encodeURIComponent(ref);
		} catch (err) {
			setStatus(form, 'error', form.dataset.msgError || 'Une erreur réseau est survenue.');
			setSubmitting(form, false);
		}
	}

	function extractServerMessage(raw) {
		try {
			var arr = JSON.parse(raw);
			if (Array.isArray(arr) && arr.length) {
				var first = JSON.parse(arr[0]);
				return first.message || null;
			}
		} catch (e) { /* noop */ }
		return null;
	}

	function trackLeadConversion(endpoint, payload) {
		var leadType = deriveLeadType(endpoint);
		if (!leadType) {
			return Promise.resolve();
		}
		
		var eventParams = { lead_type: leadType };
		if (payload.source) eventParams.source = payload.source;
		if (payload.utm_source) eventParams.utm_source = payload.utm_source;
		if (payload.utm_medium) eventParams.utm_medium = payload.utm_medium;
		if (payload.utm_campaign) eventParams.utm_campaign = payload.utm_campaign;
		if (payload.utm_content) eventParams.utm_content = payload.utm_content;
		if (payload.utm_term) eventParams.utm_term = payload.utm_term;
		
		// Déléguer à __atTrackLead qui gère GA4 (beacon), Meta, LinkedIn
		// et retourne une Promise qui se résout quand les événements sont envoyés
		if (typeof window.__atTrackLead === 'function') {
			try {
				return window.__atTrackLead(eventParams);
			} catch (e) {
				return Promise.resolve();
			}
		}
		
		return Promise.resolve();
	}

	function deriveLeadType(endpoint) {
		if (!endpoint) return null;
		if (endpoint.indexOf('submit_diagnostic') > -1) return 'diagnostic';
		if (endpoint.indexOf('submit_contact') > -1) return 'contact';
		if (endpoint.indexOf('submit_quote') > -1 || endpoint.indexOf('soumission') > -1) return 'quote';
		return 'other';
	}

	// Capture l'attribution dès qu'elle apparaît dans l'URL et la mémorise pour
	// la session : ainsi source + utm_* survivent si le visiteur navigue sur le
	// site avant de soumettre le formulaire (ex. arrive via une pub Meta, lit
	// d'autres pages, puis revient au formulaire). Exécuté au chargement.
	function captureAttribution() {
		try {
			var params = new URLSearchParams(window.location.search);
			var found = {};
			var has = false;
			ATTR_KEYS.forEach(function (k) {
				var v = params.get(k);
				if (v) { found[k] = v; has = true; }
			});
			if (has) sessionStorage.setItem(ATTR_STORE_KEY, JSON.stringify(found));
		} catch (e) { /* noop */ }
	}

	function storedAttribution() {
		try {
			var raw = sessionStorage.getItem(ATTR_STORE_KEY);
			return raw ? JSON.parse(raw) : {};
		} catch (e) { return {}; }
	}

	// Injecte source + utm_* dans le POST du formulaire.
	// Priorité : champ du formulaire > query string courante > mémoire de session.
	// Aucun hidden input requis.
	function mergeAttribution(payload) {
		try {
			var params = new URLSearchParams(window.location.search);
			var stored = storedAttribution();
			ATTR_KEYS.forEach(function (k) {
				if (payload[k]) return;
				var v = params.get(k) || stored[k];
				if (v) payload[k] = v;
			});
		} catch (e) { /* noop */ }
	}

	// Mémorise l'attribution le plus tôt possible (avant toute navigation).
	captureAttribution();

	// Anti-spam : marqueur « soumis via le formulaire JS » + temps écoulé depuis
	// le chargement (time-trap). Le serveur rejette les POST sans marqueur (bot
	// direct) ou trop rapides. Invisible pour l'utilisateur.
	function addAntispamSignals(payload) {
		payload.aw_js = '1';
		payload.aw_elapsed_ms = String(Math.max(0, Date.now() - _bundleLoadedAt));
	}

	async function formToPayload(form) {
		var data = {};
		var fields = form.querySelectorAll('input, textarea, select');
		var multiValueGroups = {};

		for (var i = 0; i < fields.length; i++) {
			var f = fields[i];
			if (!f.name) continue;
			if (f.type === 'checkbox') {
				if (f.dataset.group) {
					multiValueGroups[f.dataset.group] = multiValueGroups[f.dataset.group] || [];
					if (f.checked) multiValueGroups[f.dataset.group].push(f.value);
				} else {
					data[f.name] = f.checked ? (f.value || '1') : '';
				}
			} else if (f.type === 'radio') {
				if (f.checked) data[f.name] = f.value;
			} else if (f.type === 'file') {
				if (f.files && f.files[0]) {
					var encoded = await fileToBase64(f.files[0]);
					data[f.name + '_data'] = encoded;
					data[f.name + '_filename'] = f.files[0].name;
				}
			} else {
				data[f.name] = f.value;
			}
		}

		Object.keys(multiValueGroups).forEach(function (k) {
			data[k] = multiValueGroups[k].join(',');
		});

		return data;
	}

	function fileToBase64(file) {
		return new Promise(function (resolve, reject) {
			var reader = new FileReader();
			reader.onload = function () {
				var result = reader.result || '';
				var base64 = String(result).split(',')[1] || '';
				resolve(base64);
			};
			reader.onerror = function () { reject(new Error('read-failed')); };
			reader.readAsDataURL(file);
		});
	}

	function validateForm(form) {
		var ok = true;
		form.querySelectorAll('[required]').forEach(function (f) {
			if (!f.value || (f.type === 'checkbox' && !f.checked)) {
				markInvalid(f);
				ok = false;
			}
		});
		var emailField = form.querySelector('input[type="email"]');
		if (emailField && emailField.value && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailField.value)) {
			markInvalid(emailField);
			ok = false;
		}
		return ok;
	}

	function markInvalid(field) {
		var wrapper = field.closest('.at-field') || field.parentNode;
		if (wrapper && wrapper.classList) wrapper.classList.add('is-invalid');
		field.setAttribute('aria-invalid', 'true');
	}

	function clearErrors(form) {
		form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
		form.querySelectorAll('[aria-invalid="true"]').forEach(function (el) { el.removeAttribute('aria-invalid'); });
		setStatus(form, '', '');
	}

	function setStatus(form, state, message) {
		var status = form.querySelector('[data-form-status]');
		if (!status) return;
		status.textContent = message || '';
		if (state) status.setAttribute('data-state', state);
		else status.removeAttribute('data-state');
	}

	function setSubmitting(form, on) {
		var btn = form.querySelector('[type="submit"]');
		if (btn) btn.disabled = !!on;
	}

	// --- Multi-step (stepper) -----------------------------------------------
	function initStepperForms() {
		document.querySelectorAll('form[data-stepper]').forEach(function (form) {
			var panels = form.querySelectorAll('.at-step-panel');
			var steps = form.querySelectorAll('.at-stepper__step');
			var nextBtns = form.querySelectorAll('[data-step-next]');
			var prevBtns = form.querySelectorAll('[data-step-prev]');
			if (!panels.length) return;

			var current = 0;
			renderStep();

			nextBtns.forEach(function (btn) {
				btn.addEventListener('click', function () {
					if (!validatePanel(panels[current])) return;
					if (current < panels.length - 1) {
						current++;
						renderStep();
					}
				});
			});
			prevBtns.forEach(function (btn) {
				btn.addEventListener('click', function () {
					if (current > 0) {
						current--;
						renderStep();
					}
				});
			});

			function renderStep() {
				panels.forEach(function (p, i) { p.classList.toggle('is-active', i === current); });
				steps.forEach(function (s, i) {
					s.classList.toggle('is-active', i === current);
					s.classList.toggle('is-done', i < current);
				});
				form.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}

			function validatePanel(panel) {
				var ok = true;
				panel.querySelectorAll('[required]').forEach(function (f) {
					if (!f.value || (f.type === 'checkbox' && !f.checked)) {
						markInvalid(f);
						ok = false;
					} else {
						var w = f.closest('.at-field');
						if (w) w.classList.remove('is-invalid');
						f.removeAttribute('aria-invalid');
					}
				});
				return ok;
			}
		});
	}

	// --- Cookie helpers ------------------------------------------------------
	function setCookie(name, value, days) {
		var maxAge = days * 24 * 60 * 60;
		document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + maxAge + '; path=/; SameSite=Lax';
	}

	function getCookie(name) {
		var cookies = document.cookie.split(';');
		for (var i = 0; i < cookies.length; i++) {
			var c = cookies[i].trim();
			if (c.indexOf(name + '=') === 0) {
				return decodeURIComponent(c.substring(name.length + 1));
			}
		}
		return null;
	}
})();
